import React from "react";

interface Props {
  type: "heating" | "cooling" | "hot-water" | "coolingPiles" | "heatingPiles";
  className?: string;
  fill?: string;
  stroke?: string;
  width?: string;
  height?: string;
}

const Icon = ({ type, className, fill, stroke, width, height }: Props) => {
  const heatingIcon = (
    <svg
      className={className}
      fill={fill || "#ff5f45"}
      xmlns="http://www.w3.org/2000/svg"
      width={width || "15.46"}
      height={height || "19.553"}
      stroke={stroke || "#ff5f45"}
      viewBox="0 0 15.46 19.553"
    >
      <g id="Group_188" data-name="Group 188" transform="translate(-24.689 -22.195)">
        <path
          id="Path_734"
          data-name="Path 734"
          d="M28.065,23.372a4.41,4.41,0,0,0-2.19,4.008c0,3.072,2.142,5.4,2.142,8.628a5.594,5.594,0,0,1-2.118,4.53"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.722"
        />
        <path
          id="Path_735"
          data-name="Path 735"
          d="M33.519,23.372a4.41,4.41,0,0,0-2.19,4.008c0,3.072,2.136,5.4,2.136,8.628a5.6,5.6,0,0,1-2.112,4.53"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.722"
        />
        <path
          id="Path_736"
          data-name="Path 736"
          d="M38.972,23.372a4.411,4.411,0,0,0-2.189,4.008c0,3.072,2.135,5.4,2.135,8.628a5.6,5.6,0,0,1-2.111,4.53"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.722"
        />
      </g>
    </svg>
  );

  const coolingPilesIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="20"
      fill="none"
      viewBox="0 0 26 20"
    >
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M12.5 2c.276 0 .5.273.5.61v14.78c0 .337-.224.61-.5.61s-.5-.273-.5-.61V2.61c0-.337.224-.61.5-.61z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M15.873 3.199c.202.226.158.554-.098.733l-2.817 1.956a.647.647 0 01-.83-.087c-.203-.226-.16-.554.098-.733l2.816-1.956a.647.647 0 01.83.087z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M10.095 3.199c.152-.227.431-.265.624-.087l2.112 1.956a.585.585 0 01.074.733c-.152.227-.431.265-.624.087L10.17 3.932a.585.585 0 01-.074-.733zM12.904 15.132c.152.15.12.369-.073.488l-2.112 1.305c-.192.12-.471.093-.623-.057-.152-.15-.12-.369.073-.488l2.112-1.305c.192-.12.471-.093.623.057z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M12.128 15.132c.202-.15.575-.176.831-.057l2.816 1.305c.257.12.3.338.097.488-.202.15-.575.176-.831.057l-2.816-1.305c-.257-.12-.3-.338-.097-.488z"
        clipRule="evenodd"
      ></path>
      <g filter="url(#filter0_d)">
        <path
          fill="#4EA6FF"
          fillRule="evenodd"
          d="M6.082 6.283a.634.634 0 01.83-.207l12.784 6.868c.29.156.39.502.222.773a.634.634 0 01-.83.207L6.303 7.056a.545.545 0 01-.222-.773z"
          clipRule="evenodd"
        ></path>
      </g>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M8.298 5.004c.19-.03.367.112.395.317l.303 2.25c.028.205-.104.395-.294.425-.19.03-.367-.112-.395-.317l-.303-2.25c-.028-.205.104-.395.294-.425z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M8.972 7.297c.08.242-.018.516-.22.612L6.54 8.966c-.202.097-.43-.021-.511-.263-.08-.242.018-.516.22-.612L8.46 7.034c.202-.097.43.021.511.263zM17.298 12.005c.19-.04.367.15.395.423l.303 3c.028.273-.104.527-.294.567-.19.04-.367-.15-.395-.423l-.303-3c-.028-.273.104-.527.294-.567z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M19.972 11.297c.08.242-.018.516-.22.612l-2.213 1.057c-.202.097-.43-.021-.511-.263-.08-.242.018-.516.22-.612l2.213-1.057c.202-.097.43.021.511.263zM19.918 6.283a.545.545 0 01-.222.773L6.913 13.924a.634.634 0 01-.831-.207.545.545 0 01.222-.773l12.783-6.868a.634.634 0 01.831.207z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M6.028 11.297c.08-.242.31-.36.51-.263l2.214 1.057c.202.096.3.37.22.612-.08.242-.31.36-.51.263L6.247 11.91c-.202-.096-.3-.37-.22-.612z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M8.702 12.005c.19.04.322.294.294.568l-.303 2.999c-.028.273-.205.463-.395.423-.19-.04-.322-.294-.294-.568l.303-2.999c.028-.273.205-.463.395-.423zM17.028 7.297c.08-.242.31-.36.51-.263l2.214 1.057c.202.096.3.37.22.612-.08.242-.31.36-.51.263L17.247 7.91c-.202-.096-.3-.37-.22-.612z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#4EA6FF"
        fillRule="evenodd"
        d="M17.702 5.004c.19.03.322.22.294.425l-.303 2.25c-.028.205-.205.347-.395.317-.19-.03-.322-.22-.294-.425l.303-2.25c.028-.205.205-.347.395-.317z"
        clipRule="evenodd"
      ></path>
      <defs>
        <filter
          id="filter0_d"
          width="26"
          height="20"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="3"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.184314 0 0 0 0 0.482353 0 0 0 0 0.823529 0 0 0 0.302 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
        </filter>
      </defs>
    </svg>
  );

  const coolingIcon = (
    <svg
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width={width || "36.566"}
      height={height || "29.738"}
      stroke={stroke || "#4ea6ff"}
      viewBox="0 0 36.566 29.738"
    >
      <defs>
        <filter
          id="Line_98"
          width="36.566"
          height="29.738"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#2f7bd2" floodOpacity="0.302"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 136" transform="translate(9.787 5.539)">
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.758"
          d="M0 0L0 18.666"
          data-name="Line 93"
          transform="translate(8.496)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M2.748 0L0 2.166"
          data-name="Line 94"
          transform="translate(8.496 1.11)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 0L2.748 2.166"
          data-name="Line 95"
          transform="translate(5.748 1.11)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 2.172L2.748 0"
          data-name="Line 96"
          transform="translate(5.748 15.636)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M2.748 2.172L0 0"
          data-name="Line 97"
          transform="translate(8.496 15.636)"
        ></path>
        <g filter="url(#Line_98)" transform="translate(-9.79 -5.54)">
          <path
            fill="none"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.758"
            d="M0 0L16.164 9.336"
            data-name="Line 98"
            transform="translate(10.2 10.2)"
          ></path>
        </g>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 0L0.504 3.468"
          data-name="Line 99"
          transform="translate(2.748 2.838)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 1.296L3.252 0"
          data-name="Line 100"
          transform="translate(0 6.306)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0.504 3.462L0 0"
          data-name="Line 101"
          transform="translate(13.956 12.486)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M3.252 0L0 1.296"
          data-name="Line 102"
          transform="translate(13.956 11.19)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.758"
          d="M0 9.336L16.164 0"
          data-name="Line 103"
          transform="translate(.414 4.788)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 0L3.252 1.296"
          data-name="Line 104"
          transform="translate(0 11.19)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 3.462L0.504 0"
          data-name="Line 105"
          transform="translate(2.748 12.486)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M3.252 1.296L0 0"
          data-name="Line 106"
          transform="translate(13.956 6.306)"
        ></path>
        <path
          fill="none"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0.504 0L0 3.468"
          data-name="Line 107"
          transform="translate(13.956 2.838)"
        ></path>
      </g>
    </svg>
  );

  const hotwaterIcon = (
    <svg
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="20.796"
      height="22.142"
      viewBox="0 0 20.796 22.142"
    >
      <g data-name="Group 133" transform="translate(.681)">
        <path
          fill="#fff"
          d="M39.718 29.512a4.934 4.934 0 00-3.528-1.47H22.084v1.734h14.088c.87 0 0 .2.642.816s1.2-.45 1.2.42v2.6h1.74v-2.6c.03-1.32.9-.558-.036-1.5z"
          data-name="Path 737"
          transform="translate(-22.084 -21.484)"
        ></path>
        <path
          fill="none"
          stroke="#ff5f45"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M15.54 14.952a2.094 2.094 0 00-.81 1.4c0 1.122.8 2.082.774 3s-.294.984-.774 1.572"
          data-name="Path 738"
        ></path>
        <path
          fill="none"
          stroke="#ff5f45"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M18.9 14.952a2.093 2.093 0 00-.81 1.4c0 1.122.8 2.082.78 3s-.3.984-.78 1.572"
          data-name="Path 739"
        ></path>
        <path
          fill="#161616"
          d="M40.072 28.1a4.943 4.943 0 00-3.534-1.47H22.432v1.746h14.094a3.228 3.228 0 013.24 3.216v2.634h1.74v-2.6a4.931 4.931 0 00-1.434-3.526z"
          data-name="Path 740"
          transform="translate(-22.084 -21.484)"
        ></path>
        <path
          fill="#161616"
          d="M38.452 34.216v-2.61a1.913 1.913 0 00-.534-1.374 1.945 1.945 0 00-1.38-.57H22.432v1.716h14.106a.206.206 0 01.156.06.192.192 0 01.054.138V34.2z"
          data-name="Path 741"
          transform="translate(-22.084 -21.484)"
        ></path>
        <path
          fill="#161616"
          d="M0 0H2.16V1.722H0z"
          data-name="Rectangle 2463"
          transform="translate(15.732 11.01)"
        ></path>
        <path
          fill="none"
          stroke="#161616"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M0 0L0 17.052"
          data-name="Line 108"
          transform="translate(.186)"
        ></path>
        <path
          fill="none"
          stroke="#161616"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M0 4.164L0 0"
          data-name="Line 109"
          transform="translate(9.552 1.158)"
        ></path>
        <path
          fill="none"
          stroke="#161616"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M0 0L6.654 0"
          data-name="Line 110"
          transform="translate(6.21 .87)"
        ></path>
      </g>
    </svg>
  );

  const heatingPilesIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g
        stroke="#FF5F45"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.2"
        opacity="0.8"
      >
        <path
          d="M3 14.21a3.597 3.597 0 003.269 1.786c2.505 0 4.404-1.747 7.037-1.747A4.562 4.562 0 0117 15.977M3 9.766a3.596 3.596 0 003.269 1.786c2.505 0 4.404-1.742 7.037-1.742A4.567 4.567 0 0117 11.532M3 5.317a3.597 3.597 0 003.269 1.785c2.505 0 4.404-1.741 7.037-1.741A4.567 4.567 0 0117 7.082"
          opacity="0.8"
        ></path>
      </g>
    </svg>
  );

  if (type === "heating") return heatingIcon;
  if (type === "cooling") return coolingIcon;
  if (type === "hot-water") return hotwaterIcon;
  if (type === "coolingPiles") return coolingPilesIcon;
  if (type === "heatingPiles") return heatingPilesIcon;
  return <div></div>;
};

export default Icon;
